import React from 'react';
import moment from 'moment';
import { get } from 'lodash/fp';
import { Table } from 'rsuite';
import PropTypes from 'prop-types';

const { Cell } = Table;
const formatDate = (format, date) => moment(date).format(format);

const DateCell = ({ rowData, dataKey, format, emptyValue, ...props }) => (
  <Cell {...props}>
    {get(dataKey, rowData)
      ? formatDate(format, get(dataKey, rowData))
      : emptyValue}
  </Cell>
);

DateCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({}),
  emptyValue: PropTypes.string,
  format: PropTypes.string
};

DateCell.defaultProps = {
  rowData: null,
  emptyValue: 'N/A',
  format: 'MM/DD/YYYY'
};

export default DateCell;
